module.exports = __webpack_public_path__ + "img/v_spades.70111673.png";